import '../styles/globals.css'
import type { AppProps } from 'next/app'
import Head from 'next/head'
import theme from "./api/theme"
import { ThemeProvider } from '@mui/material/styles';

function MyApp({ Component, pageProps }: AppProps) {
	return (
		<>
			<Head>
				<link rel="icon" type="image/svg+xml" href="/holmiappcolor.svg" />
				<meta name="viewport" content="minimum-scale=1,initial-scale=1,width=device-width" />
			</Head>
			<ThemeProvider theme={theme}>
        		<Component {...pageProps} />
      		</ThemeProvider>
		</>
	)
}
export default MyApp
